import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=176068c5"
import script from "./BookingList.vue?vue&type=script&lang=ts"
export * from "./BookingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports